import type { AnyDomainEvent } from '@abastece/shared';
import { orderKey } from '@abastece/shared';
import type { ApplyResult, Reader } from '../state.js';

export async function reduceUsuario(
  event: AnyDomainEvent,
  read: Reader,
): Promise<ApplyResult | null> {
  const rev = orderKey(event);

  switch (event.type) {
    case 'usuario.creado': {
      const { usuarioId, nombre, rol, pinHash } = event.payload;
      return {
        effects: [
          {
            kind: 'usuario.upsert',
            id: usuarioId,
            row: { id: usuarioId, nombre, rol, pinHash, activo: true, rev },
          },
        ],
        rejections: [],
      };
    }

    case 'usuario.actualizado': {
      const { usuarioId, nombre, rol } = event.payload;
      const existing = await read.usuario(usuarioId);
      if (!existing) {
        return { effects: [], rejections: [{ eventId: event.id, reason: 'Usuario no existe' }] };
      }
      const patch: Record<string, unknown> = {};
      if (nombre !== undefined) patch['nombre'] = nombre;
      if (rol !== undefined) patch['rol'] = rol;
      return { effects: [{ kind: 'usuario.patch', id: usuarioId, rev, patch }], rejections: [] };
    }

    case 'usuario.pin_cambiado': {
      const { usuarioId, pinHash } = event.payload;
      const existing = await read.usuario(usuarioId);
      if (!existing) {
        return { effects: [], rejections: [{ eventId: event.id, reason: 'Usuario no existe' }] };
      }
      return {
        effects: [{ kind: 'usuario.patch', id: usuarioId, rev, patch: { pinHash } }],
        rejections: [],
      };
    }

    case 'usuario.desactivado':
      return {
        effects: [
          { kind: 'usuario.patch', id: event.payload.usuarioId, rev, patch: { activo: false } },
        ],
        rejections: [],
      };

    case 'usuario.reactivado':
      return {
        effects: [
          { kind: 'usuario.patch', id: event.payload.usuarioId, rev, patch: { activo: true } },
        ],
        rejections: [],
      };

    default:
      return null;
  }
}
